/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualKeyPublicBase58: core.serialization.ObjectSchema<
    serializers.NotEqualKeyPublicBase58.Raw,
    Truvity.NotEqualKeyPublicBase58
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace NotEqualKeyPublicBase58 {
    export interface Raw {
        value: string;
    }
}
